import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hiddenInput", "tagList"]

  connect() {
    // Initialize the hidden input with any existing tags
    this.updateHiddenInput()
  }

  addTag(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      const value = this.inputTarget.value.trim()
      if (value) {
        this.addTagToUI(value)
        this.inputTarget.value = ""
        this.updateHiddenInput()
      }
    }
  }

  removeTag(event) {
    const tag = event.currentTarget.dataset.tag
    const tagElement = event.currentTarget.closest("span")
    tagElement.remove()
    this.updateHiddenInput()
  }

  addTagToUI(tag) {
    const tagElement = document.createElement("span")
    tagElement.className = "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
    tagElement.innerHTML = `
      ${tag}
      <button type="button" 
              class="ml-1.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-blue-400 hover:bg-blue-200 hover:text-blue-500 focus:bg-blue-500 focus:text-white focus:outline-none"
              data-action="click->tag-input#removeTag"
              data-tag="${tag}">
        <span class="sr-only">Remove ${tag}</span>
        <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
          <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
        </svg>
      </button>
    `
    this.tagListTarget.appendChild(tagElement)
  }

  updateHiddenInput() {
    const tags = Array.from(this.tagListTarget.querySelectorAll("span"))
      .map(span => span.textContent.trim())
      .filter(tag => tag)
    this.hiddenInputTarget.value = tags.join("\n")
  }
} 